/**
 * @deprecated
 * Onboarding kind query parameter has been deprecated in favor of the PLG_ONBOARD_KIND path parameter
 */
export const DEPRECATED_ONBOARDING_KIND_QUERY_KEY = "kind"

export const PLG_ONBOARD_KIND_FIRM = "accountant"
export const PLG_ONBOARD_KIND_OPERATOR = "business"
export const VALID_PLG_ONBOARD_KINDS = [PLG_ONBOARD_KIND_FIRM, PLG_ONBOARD_KIND_OPERATOR] as const
export type PlgOnboardKind = (typeof VALID_PLG_ONBOARD_KINDS)[number]

export const PLG_ONBOARD_KIND_PATH_PARAM = "onboardKind"
